var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.contentLoading),expression:"contentLoading"}]},[_c('div',{staticStyle:{"margin-left":"15px","margin-right":"15px","padding-bottom":"30px"},domProps:{"innerHTML":_vm._s(_vm.sysConfig.paramKeyValue)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }